import merge from 'lodash/merge'

import { useBuilder } from '@/lib/builder/extension/useBuilder'

import { type PdfSection } from '../../../WebsiteBuilder.types'

const websiteBuilderQueue = useBuilder('websiteBuilder')

const PdfCommands = {
  updateBlock: websiteBuilderQueue.createBlockCommand<PdfSection>({
    commit: async (currentData, ctx) => {
      return merge(currentData, ctx.update)
    },
  }),
}

export { PdfCommands }
